export default "__VITE_ASSET__CRCR1QZP__"